const BrowserActionTypes = {
  SET_BROWSER_TOKEN: 'SET_BROWSER_TOKEN',
  SET_BROWSER_TOKEN_ERROR: 'SET_BROWSER_TOKEN_ERROR',
}

export const ServiceLoadingTypes = {
  GET_TOKEN: 'GET_TOKEN',
}

export default BrowserActionTypes
